import { useEffect, useRef } from "react";
import {
  clearReportPreviewCache,
  scheduleReportPreviewPreload,
} from "../cache/reportPreviewCache";

/**
 * Warms report preview chunk 1 after Property View Details main load finishes.
 * Does not affect the page loading spinner.
 */
export function usePropertyReportPreload(
  propertyMasterId,
  inspectionReferenceNumber,
  mainScreenReady,
) {
  const scheduledRef = useRef(false);

  useEffect(() => {
    if (!mainScreenReady || !propertyMasterId || !inspectionReferenceNumber) {
      return undefined;
    }

    if (scheduledRef.current) return undefined;
    scheduledRef.current = true;

    return scheduleReportPreviewPreload(
      propertyMasterId,
      inspectionReferenceNumber,
    );
  }, [propertyMasterId, inspectionReferenceNumber, mainScreenReady]);

  useEffect(() => {
    return () => {
      if (propertyMasterId && inspectionReferenceNumber) {
        clearReportPreviewCache(propertyMasterId, inspectionReferenceNumber);
      }
    };
  }, [propertyMasterId, inspectionReferenceNumber]);
}
